exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".craverGiftCardForm-cardForm {\n  display: flex;\n  flex-direction: column; }\n\n.craverGiftCardForm-fullWidthInput {\n  width: 100%;\n  margin: 8px 0; }\n", ""]);

// exports
